<template>
    <div class="piano">
        <h1> ♪ </h1>
        <real-piano-function/>
    </div>
</template>
<script>
import RealPianoFunction from '@/components/RealPianoFunction.vue'

export default {
    components: { RealPianoFunction}
}
</script>
